import ForgotPassword from './ForgotPassword.container';
export default ForgotPassword;
